import { FormQuestionData } from "types/gql-types";

type ControlProps<T extends QuestionType> = {
  question: Handle<T>;
  identity: Identity;
  render: (props: QuestionProps<any>) => React.ReactNode;
  validate: (suffix?: string) => (value: any) => Promise<undefined | string | void>;
}

export type QuestionType = FormQuestionData["__typename"];

export const enum FormStatus {
  ValidationError,
  ServerError,
}

// Represents all possible Formik form value types.
// eslint-disable-next-line max-len
export type FormValue = string | number | boolean | Date | Array<string> | Array<Upload> | Array<FormValues> | null;

// Represents the type for the Formik form state.
export type FormValues = {
  [key: string]: FormValue;
}

// Represents the unique identity of a question.
type Identity = {
  name: string;
  suffix?: string;
  context: string[];
  key?: string;
}

// Returns the React prop types for the given control string.
type QuestionProps<T extends QuestionType> = {
  question: Handle<T>;
  identity?: Identity;
}

// Returns the type of a React functional component whose props contain data
// for the control type given by the string.
// ex. Control<"select"> => { question: Handle<"select">, identity? Identity }
export type Control<T extends QuestionType> = React.FC<ControlProps<T>>;

// Returns the narrowed type of `Question` from the control string given.
// ex. Handle<"select"> => Data<"select", { options: ... }>
// export type Handle<T extends string> = Extract<Question, { type: T }>;
export type Handle<T extends QuestionType> = Extract<FormQuestionData, { __typename: T }>;

export type Upload = {
  id: string | null;
  tempID: string;
  name: string | null;
  status: Status;
}

export enum Status {
  None,
  Uploading,
  Finished,
  Errored,
}
